import { createContext, useContext, ReactNode } from 'react';
import { UserRoleValue } from '@/services/urlService';

interface PostCardAuthContextValue {
  userRole: UserRoleValue;
  clientId: string;
  authToken?: string;
}

const PostCardAuthContext = createContext<PostCardAuthContextValue | undefined>(undefined);

export interface PostCardAuthProviderProps {
  children: ReactNode;
  userRole: UserRoleValue;
  clientId: string;
  authToken?: string;
}

export const PostCardAuthProvider: React.FC<PostCardAuthProviderProps> = ({
  children,
  userRole,
  clientId,
  authToken,
}) => {
  return (
    <PostCardAuthContext.Provider value={{ userRole, clientId, authToken }}>
      {children}
    </PostCardAuthContext.Provider>
  );
};

export const usePostCardAuth = () => {
  const context = useContext(PostCardAuthContext);
  if (!context) {
    throw new Error('usePostCardAuth must be used within PostCardAuthProvider');
  }
  return context;
};

export const usePostCardAuthOptional = () => {
  return useContext(PostCardAuthContext);
};
